import { z } from 'zod';

export const emailStepSchema = z.object({
  email: z.string().email(),
});

export const passwordStepSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1),
});

export type EmailStepInput = z.infer<typeof emailStepSchema>;
export type PasswordStepInput = z.infer<typeof passwordStepSchema>;
